<script>
	// NPM Modules
	import Papa from 'papaparse';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Services
	import { notify } from '@/Services/Notify';
	// Stores
	import ACLStore from '@/Stores/ACLStore';
	import BonusBetStore from '@/Stores/User/BonusBetStore';
	import SelectInput from '@/Components/SelectInput.svelte';
	import TextAreaInput from '@/Components/TextAreaInput.svelte';
	import Prompt from '@/Components/Prompt.svelte';

	export let open = false;

	let errors = null;
	let bulkBonusFile;
	let bonusTypeId;
	let bonusNote;
	let sending = false;
	let checkValue = false;
	let promptRequired = false;

	$: filterMeta = $BonusBetStore && BonusBetStore.getFilterMeta();
	BonusBetStore.getUserBonusBets(1);

	function checkUploadFilForConfirmation() {
		let headerIndex = false;
		if (bulkBonusFile && bonusTypeId) {
			sending = true;
			promptRequired = false;
			Papa.parse(bulkBonusFile, {
				worker: true,
				step: function (row) {
					if (!headerIndex) {
						for (const header in row.data) {
							if (row.data[header] == 'amount' || row.data[header] == 'Amount' || row.data[header] == 'AMOUNT') {
								headerIndex = header;
							}
						}
					} else {
						if (parseInt(row.data[headerIndex]) > 99900) {
							promptRequired = true;
						}
					}
				},
				complete: function () {
					if (promptRequired) {
						checkValue = true;
					} else {
						uploadBulkBonusCSV();
					}
				},
				error: function (err) {
					sending = false;
					notify({
						type: 'danger',
						title: 'Error!',
						message: err.message,
						timeout: 3
					});
				}
			});
		} else {
			notify({
				type: 'danger',
				title: 'Error!',
				message: 'Please select a bonus type and select a file to upload',
				timeout: 3
			});
		}
	}

	function uploadBulkBonusCSV() {
		if (bulkBonusFile && bonusTypeId) {
			sending = true;
			BonusBetStore.addBulkBonusToUsers(bulkBonusFile, {
				type_id: bonusTypeId,
				note: bonusNote
			})
				.then(() => {
					notify({
						type: 'success',
						title: 'User Bonuses Added',
						message: 'Bonuses successfully added to users!',
						timeout: 3
					});
					open = false;
				})
				.catch((e) => {
					errors = e;
					notify({
						type: 'danger',
						title: 'Error!',
						message: (e.error && e.error[0]) || 'Problem adding bonuses to users',
						timeout: 3
					});
				})
				.finally(() => {
					sending = false;
					promptRequired = false;
				});
		} else {
			notify({
				type: 'danger',
				title: 'Error!',
				message: 'Please select a bonus type and select a file to upload',
				timeout: 3
			});
		}
	}

	function fileChange(e) {
		bulkBonusFile = e.target.files[0];
	}
</script>

{#if checkValue}
	<Prompt
		bind:open={checkValue}
		title="Confirm promotion value"
		message="The bonus allocation seems high, Are you sure you want to go ahead?"
		onConfirm={() => uploadBulkBonusCSV()}
		on:close={() => {
			sending = false;
		}}
	/>
{/if}

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Create new next deposit promotion</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-left space-y-4 mt-4">
			<SelectInput
				label="Bonus Bet Type"
				className="py-4 w-full"
				name="type_id"
				required={true}
				bind:value={bonusTypeId}
				errors={errors && errors.type_id}
			>
				<option value={undefined} selected disabled> * Please select *</option>
				{#each (filterMeta && Object.entries(filterMeta)) ?? [] as bonusType}
					<option value={bonusType[0]}>{bonusType[1]}</option>
				{/each}
			</SelectInput>
			<TextAreaInput
				label="Note: [optional]"
				name="note"
				className="pb-4 w-full"
				bind:value={bonusNote}
				required={true}
				placeholder="Description *** Visible to clients! ***"
			/>
			<TextInput
				label="Add bonuses to users Via CSV"
				name="bonus_user_list"
				type="file"
				className="w-full mt-4"
				required={true}
				errors={errors && errors.bonus_user_list}
				on:change={fileChange}
				accept=".csv"
			/>
			<label class="text-danger" for="bonus_user_list"
				>The uploaded file MUST HAVE columns: 'pin', 'amount' (in cents), and 'valid_days'</label
			>
			<LoadingButton
				on:click={checkUploadFilForConfirmation}
				loading={sending}
				className="my-4 btn {!($ACLStore && ACLStore.granted('promotions.update'))
					? 'btn-primary-action-disabled'
					: 'btn-primary-action'}"
				disabled={!($ACLStore && ACLStore.granted('promotions.update'))}
			>
				{sending ? 'Uploading' : 'Upload'}
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}>Cancel</button>
		</div>
	</Modal>
{/if}
